// app/javascript/projects/components/ProjectsDisplay.jsx

import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSubscription } from '../../hooks/subscriptions/queries';
import { useCreateProject } from '../../hooks/projects/mutations';
import { isCancelled } from '../../utils/subscriptionUtils';
import PageLoadingComponent from './PageLoadingComponent';

function ProjectNew() {
  const history = useHistory();
  const { data: subscription, isLoading: subscriptionLoading } = useSubscription();
  const { mutate: createProject, data: newProject } = useCreateProject();

  useEffect(() => {
    // Only proceed once subscription data is loaded
    if (!subscriptionLoading) {
      // If no subscription exists, redirect to users page
      if (!subscription) {
        history.push('/users');
      } else if (isCancelled(subscription)) {
        history.push('/users');
      } else {
        // Create new project with empty name and null description
        createProject({ name: "", description: null });
      }
    }
  }, [subscriptionLoading, subscription, createProject, history]);

  useEffect(() => {
    // Navigate to new project once it's created
    if (newProject?.id) {
      history.push(`/projects/${newProject.id}`);
    }
  }, [newProject, history]);

  // Show loading while checking subscription or creating project
  return <PageLoadingComponent />;
}

export default ProjectNew;